module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M5.35 23.08c-1.22 1.23-3.21 1.23-4.43 0-1.23-1.22-1.23-3.21 0-4.43L7.57 12 .92 5.35C-.31 4.13-.31 2.14.92.92 2.14-.31 4.13-.31 5.35.92L12 7.57 18.65.92c1.22-1.23 3.21-1.23 4.43 0 1.23 1.22 1.23 3.21 0 4.43L16.43 12l6.65 6.65c1.23 1.22 1.23 3.21 0 4.43-1.22 1.23-3.21 1.23-4.43 0L12 16.43l-6.65 6.65z\" fill=\"FILL_COLOR\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./node_modules/shared-web/src/components/widget/Header/images/close-button.svg
// module id = bZAu
// module chunks = 88